import { ColDef } from 'ag-grid-community';

export interface ColumnDefinition extends ColDef {
  events?: { [key: string]: (event: unknown) => void };
}

export type ColumnDefiner = ColumnDefinition | (() => ColumnDefinition);
export type ColumnDefinitions = { [key: string]: ColumnDefiner };

export abstract class ColumnGroup {
  protected abstract columnDefinitions: ColumnDefinitions;

  public getColumnDefinition(columnName: string): ColumnDefiner | null {
    if (this.columnDefinitions.hasOwnProperty(columnName)) {
      return this.columnDefinitions[columnName];
    }

    return null;
  }

  public getAllColumns(): ColumnDefinitions {
    return this.columnDefinitions;
  }
}
